export default "__VITE_ASSET__fac53102__"